import log from "loglevel";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        let timeId = setTimeout(() => {
            log.log("scrolling to top");
            window.scrollTo(0, 0);
        }, 100);
        return () => clearTimeout(timeId)
    }, [location.pathname, location.key]);

    return null;
};

export default ScrollToTop;
